import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { AcademicWritingTask1 } from "@modules/elearning/lead";

const IELTSAcademicWritingTask1 = () => {
  return (
    <LayoutMain
      title="IELTS Masterclass - Essential Tips to Score Band 8+ in IELTS Academic Writing Task 1"
      footer_with_evaluation
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/elearning/lead/essential-tips-to-score-band-8+-in-IELTS-academic-writing-task-1`}
    >
      <AcademicWritingTask1 />
    </LayoutMain>
  );
};

export default IELTSAcademicWritingTask1;
